  import { AfterViewInit, Component, HostListener, Input, OnInit } from '@angular/core';
import * as $ from 'jquery';

@Component({
  selector: 'app-technology',
  templateUrl: './technology.component.html',
  styleUrls: ['./technology.component.css']
})
export class TechnologyComponent implements AfterViewInit {

  @Input() scrollPage:any;
  aiStickyFlag:boolean = false;
  roSitckyFlag:boolean= false;
  viStickyFlag:boolean = false; 
  private loadCount:number =0;

  constructor() 
  { 
  
  }

  ngAfterViewInit(){
    
  }

  ngOnInit(): void {
    window.addEventListener('scroll', this.scrollEvent, true);
  }

  scrollEvent =(event:any)=> { 
    let scrollLocation = document.documentElement.scrollTop;
    let positionAi1:any = document.getElementById("ai")?.offsetTop;
    let positionRo1:any = document.getElementById("robotics")?.offsetTop;
    let positionVi1:any =document.getElementById("vision")?.offsetTop;

    if(scrollLocation < positionAi1 -50 ){
      this.aiStickyFlag = false;
    }
    else if( (scrollLocation < positionRo1 -50) ){
      this.aiStickyFlag = true;
      this.roSitckyFlag = false;
      this.viStickyFlag = false;
      $('#ai .title select').val("ai01").prop("selected", true);
      // (document.querySelector('#ai .title select')as HTMLElement).nodeValue = "ai01";

      this.checkAiPosition(scrollLocation);
    }
    else if((scrollLocation > positionRo1 +50 ) && (scrollLocation < positionVi1 - 50)){
      this.aiStickyFlag = false;
      this.roSitckyFlag = true;
      this.viStickyFlag = false;
      $('#robotics .title select').val("ro01").prop("selected", true);
      this.checkRoPosition(scrollLocation);
    }
    else if(scrollLocation > positionVi1 + 50){
      this.viStickyFlag = true;
      this.roSitckyFlag =false;
      this.aiStickyFlag =false;
      $('#vision .title select').val("vi01").prop("selected", true);
      this.checkViPosition(scrollLocation);
    }

  }
  

  checkAiPosition( scrollLocation:number ):void{
    let positionAi2:any = document.getElementById("ai02")?.offsetTop;
    let positionAi3:any = document.getElementById("ai03")?.offsetTop;
    let positionAi4:any = document.getElementById("ai04")?.offsetTop;
    let positionAi5:any = document.getElementById("ai05")?.offsetTop;

    if(scrollLocation < positionAi2 - 50){
      $('#aiContents').val("ai01").prop("selected", true);
    }
    else if(scrollLocation < positionAi3 - 50){
      $('#aiContents').val("ai02").prop("selected", true);
    }
    else if(scrollLocation < positionAi4 - 50){
      $('#aiContents').val("ai03").prop("selected", true);
    }
    else if(scrollLocation < positionAi5 - 50){
      $('#aiContents').val("ai04").prop("selected", true);
    }
    else{
      $('#aiContents').val("ai05").prop("selected", true);
    }

  }

  checkRoPosition( scrollLocation:number ):void{
    let positionRo2:any =document.getElementById("ro02")?.offsetTop;

    if(scrollLocation < positionRo2 -50){
      $('#roboContents').val("ro01").prop("selected", true);
    }
    else{
      $('#roboContents').val("ro02").prop("selected", true);
    }
  }

  checkViPosition( scrollLocation:number ):void{
    let positionVi2:any = document.getElementById("vi02")?.offsetTop;
    let positionVi3:any = document.getElementById("vi03")?.offsetTop;
    let positionVi4:any = document.getElementById("vi04")?.offsetTop;
    let positionVi5:any =document.getElementById("vi05")?.offsetTop;

    if(scrollLocation < positionVi2 - 50){
      $('#visionContents').val("vi01").prop("selected", true);
    }
    else if(scrollLocation < positionVi3 - 50){
      $('#visionContents').val("vi02").prop("selected", true);
    }
    else if(scrollLocation < positionVi4 - 50){
      $('#visionContents').val("vi03").prop("selected", true);
    }
    else if(scrollLocation < positionVi5 - 50){
      $('#visionContents').val("vi04").prop("selected", true);
    }
    else{
      $('#visionContents').val("vi05").prop("selected", true);
    }
  }
  scrollMoveToView  (event:any) {
    document.getElementById(event.target.value)?.scrollIntoView();
    
  }

  ngOnDestroy() {
    window.removeEventListener('scroll', this.scrollEvent, true);
  }

  afterLoad(){
    this.loadCount++;

    if(this.loadCount>12){
    document.getElementById(this.scrollPage)?.scrollIntoView();
     
    }
  }
}
